import React, { useEffect, useState } from 'react'
import activityTrackingService from '../../../../services/activityTrackingService'
import RoomList from './RoomList'
import CreateRoom from './CreateRoom'
import { trackingEvent } from '../../../../constants'
import UpdateRoom from './UpdateRoom'
import Box from '../../../Shared/Box'
import { Container } from '../../../Shared/Grid'

const ROOM_BROWSER_MODES = {
  LIST: 1,
  UPDATE_ROOM: 2,
  CREATE_ROOM: 3
}
export default function RoomBrowser ({
                                       property,
                                       rooms,
                                       images,
                                       roomAttributes,
                                       onRoomsChange,
                                       onImagesChange,
                                       uploadQueue,
                                       onUploadFiles,
                                       onUploadQueueImageRemove,
                                     }) {
  const [mode, setMode] = useState(ROOM_BROWSER_MODES.LIST)
  const [selectedRoom, setSelectedRoom] = useState(null)

  useEffect(() => {
    activityTrackingService.trackPageView('Edit Rooms', {
      giataId: property.giataId,
    })
  }, [property.giataId])

  const onCreateRoomClick = React.useCallback(() => {
    setSelectedRoom(null)
    setMode(ROOM_BROWSER_MODES.CREATE_ROOM)
  }, [])

  const onRoomCreated = React.useCallback(
    (createdRoom) => {
      const newRooms = [...rooms, createdRoom]
      onRoomsChange(newRooms)
      setMode(ROOM_BROWSER_MODES.LIST)
      setSelectedRoom(null)
    },
    [rooms, onRoomsChange]
  )

  const onRoomCreateOrUpdateCancel = React.useCallback(() => {
    activityTrackingService.trackEvent(trackingEvent.cancelRoomEdit)
    setSelectedRoom(null)
    setMode(ROOM_BROWSER_MODES.LIST)
  }, [])

  const onRoomChanged = React.useCallback(
    (room) => {
      const index = rooms.findIndex((r) => r.id === room.id)
      if (index !== -1) {
        const newRooms = [...rooms]
        newRooms[index] = room
        onRoomsChange(newRooms)
        setMode(ROOM_BROWSER_MODES.LIST)
        setSelectedRoom(null)
      }
    },
    [rooms, onRoomsChange]
  )

  const onRoomSelected = React.useCallback(
    (room) => {
      setSelectedRoom(room)
      setMode(ROOM_BROWSER_MODES.UPDATE_ROOM)
    },
    []
  )

  const onRoomRemoved = React.useCallback(
    (room) => {
      const newRooms = rooms.filter((r) => r.id !== room.id)
      onRoomsChange(newRooms)
    },
    [rooms, onRoomsChange]
  )

  // We keep roomList to keep roomList state for better ux
  const roomListElement = <RoomList
    hidden={mode !== ROOM_BROWSER_MODES.LIST}
    property={property}
    rooms={rooms}
    roomAttributes={roomAttributes}
    onCreateRoomClick={onCreateRoomClick}
    onRoomSelected={onRoomSelected}
    onRoomRemoved={onRoomRemoved}
    onImagesChange={onImagesChange}
    images={images}
    uploadQueue={uploadQueue}
    onUploadFiles={onUploadFiles}
    onUploadQueueImageRemove={onUploadQueueImageRemove}
  />
  const elementsToRender = [roomListElement]
  switch (mode) {
    case ROOM_BROWSER_MODES.UPDATE_ROOM:
      elementsToRender.push(<div className={'page'}>
          <Box>
            <Container fluid gutterWidth={5}>
              <UpdateRoom
                onRoomChanged={onRoomChanged}
                onCancel={onRoomCreateOrUpdateCancel}
                roomAttributes={roomAttributes}
                room={selectedRoom}/>
            </Container>
          </Box>
        </div>
      )
      break
    case ROOM_BROWSER_MODES.CREATE_ROOM:
      elementsToRender.push(<div className={'page'}>
        <Box>
          <Container fluid gutterWidth={5}>
            <CreateRoom
              onRoomCreated={onRoomCreated}
              onCancel={onRoomCreateOrUpdateCancel}
              roomAttributes={roomAttributes}
              giataId={property.giataId}/>
          </Container>
        </Box>
      </div>)
      break
    default:
      break
  }
  return (
    <>
      {elementsToRender.map((element, index) => (
        <React.Fragment key={index}>{element}</React.Fragment>
      ))}
    </>
  )
}
